var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.timestamp)?_c('p',{staticClass:"mt-10"},[_vm._v("\n        "+_vm._s(_vm.timestamp)+"\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }